(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-home"] && !Shopify.designMode) return;
  try {
    
  const initializeEditorialCarousels = (root = document) => {
    root.querySelectorAll('[data-editorial-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';
      const track = carousel.querySelector('[data-carousel-track]');
      const previous = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      if (!track || !previous || !next) return;
      const scroll = (direction) => {
        const card = track.querySelector('[data-carousel-item]');
        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      };
      previous.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
    });
  };
  initializeEditorialCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeEditorialCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('recently-viewed-strip')) {
    customElements.define('recently-viewed-strip', class extends HTMLElement {
      connectedCallback() {
        const current = {
          id: this.dataset.productId,
          title: this.dataset.productTitle,
          url: this.dataset.productUrl,
          image: this.dataset.productImage || '',
          price: this.dataset.productPrice || ''
        };
        if (!current.id || !current.title || !current.url) return;

        try {
          const key = 'pdpRecentlyViewedCards';
          const saved = JSON.parse(localStorage.getItem(key) || '[]');
          const previous = Array.isArray(saved) ? saved.filter(item => item && item.id !== current.id) : [];
          const grid = this.querySelector('[data-recently-viewed-grid]');
          let displayed = 0;

          for (const item of previous.slice(0, 4)) {
            if (!item.title || !item.url) continue;
            const url = new URL(item.url, location.origin);
            if (url.origin !== location.origin || !url.pathname.includes('/products/')) continue;
            const link = document.createElement('a');
            link.className = 'recently-viewed-strip__card';
            link.href = url.href;
            if (item.image) {
              const image = document.createElement('img');
              image.src = item.image;
              image.alt = item.title;
              image.loading = 'lazy';
              link.append(image);
            }
            const title = document.createElement('span');
            title.className = 'recently-viewed-strip__title';
            title.textContent = item.title;
            link.append(title);
            const price = document.createElement('span');
            price.className = 'recently-viewed-strip__price';
            const formattedPrice = String(item.price || '').trim();
            price.textContent = formattedPrice.startsWith('€') ? formattedPrice.slice(1).trim() + ' €' : formattedPrice;
            link.append(price);
            if (formattedPrice) {
              const taxHint = document.createElement('small');
              taxHint.className = 'recently-viewed-strip__tax-hint';
              taxHint.textContent = this.dataset.priceTaxHint || '';
              link.append(taxHint);
            }
            grid.append(link);
            displayed += 1;
          }

          if (displayed) this.hidden = false;
          localStorage.setItem(key, JSON.stringify([current, ...previous].slice(0, 8)));
        } catch (error) {
          this.hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scm-neu-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__scmComplete) return;
  window.__scmComplete = true;

  async function addLines(ids) {
    var lines = ids.map(function (id) { return { merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 }; });
    var actions = window.Shopify && window.Shopify.actions;
    if (actions && actions.updateCart) {
      var res = await actions.updateCart({ lines: lines }, { context: 'product' });
      if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
      if (actions.openCart) actions.openCart();
      return;
    }
    var r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; }) })
    });
    if (!r.ok) throw new Error('cart');
    window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
  }

  document.addEventListener('click', async function (e) {
    var one = e.target.closest('[data-scm-add]');
    var all = e.target.closest('[data-scm-add-all]');
    var btn = one || all;
    if (!btn) return;
    e.preventDefault();
    var ids = one ? [one.getAttribute('data-scm-add')] : all.getAttribute('data-scm-add-all').split(',').filter(Boolean);
    btn.classList.add('is-busy');
    try {
      await addLines(ids);
      if (one) one.classList.add('is-added');
      if (all) {
        document.querySelectorAll('[data-scm-add]').forEach(function (b) { b.classList.add('is-added'); });
      }
    } catch (err) {
      console.warn('[scm-complete]', err);
    } finally {
      btn.classList.remove('is-busy');
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
